import { useState } from "react";
import { Box, FileCode2, Copy, Loader2, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, downloadFile, errMsg } from "@/lib/api";

const slug = (t) => t.replace(/[^A-Za-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 50);

const Btn = ({ icon: Icon, label, sub, onClick, busy, testid, primary }) => (
  <button data-testid={testid} onClick={onClick} disabled={busy}
    className={`group w-full flex items-center gap-3 px-4 py-3 border text-left transition-colors disabled:opacity-50 ${primary ? "bg-[var(--cyan)] text-[var(--bg)] border-[var(--cyan)] hover:brightness-110" : "border-[var(--line)] hover:border-[var(--cyan)]"}`}>
    {busy ? <Loader2 size={18} className="animate-spin" /> : <Icon size={18} />}
    <span className="flex-1">
      <span className="block text-sm font-semibold font-display">{label}</span>
      <span className={`block font-mono text-[10px] uppercase tracking-widest ${primary ? "opacity-70" : "text-[var(--muted)]"}`}>{sub}</span>
    </span>
  </button>
);

export const ExportPanel = ({ project }) => {
  const [busy, setBusy] = useState("");
  const run = (key, fn, ok) => async () => {
    setBusy(key);
    try { await fn(); toast.success(ok); } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  const base = `/projects/${project.project_id}/export`;
  const name = slug(project.title);

  return (
    <div className="space-y-2" data-testid="export-panel">
      <Btn primary testid="download-3dm-btn" icon={Box} label="Download .3dm" sub="Opens in Rhino 7 / 8" busy={busy === "3dm"}
        onClick={run("3dm", () => downloadFile(`${base}/3dm`, `${name}.3dm`), "Rhino file downloaded")} />
      <Btn testid="download-py-btn" icon={FileCode2} label="Download Rhino script" sub="rhinoscriptsyntax .py" busy={busy === "py"}
        onClick={run("py", () => downloadFile(`${base}/py`, `${name}.py`), "Rhino script downloaded")} />
      <Btn testid="copy-py-btn" icon={Copy} label="Copy script" sub="Paste in ScriptEditor" busy={busy === "copy"}
        onClick={run("copy", async () => { const { data } = await api.get(`${base}/py`, { responseType: "text" }); await navigator.clipboard.writeText(data); }, "Script copied to clipboard")} />
      <Btn testid="download-pdf-btn" icon={FileText} label="PDF drawing set" sub="Plans · electrical · plumbing" busy={busy === "pdf"}
        onClick={run("pdf", () => downloadFile(`${base}/pdf`, `${name}.pdf`), "PDF sheet downloaded")} />
      <Btn testid="download-preview-pdf-btn" icon={FileText} label="Client preview PDF" sub="Watermarked · no dimensions" busy={busy === "prev"}
        onClick={run("prev", () => downloadFile(`${base}/preview-pdf`, `${name}-preview.pdf`), "Preview PDF downloaded")} />
      <p className="text-[11px] text-[var(--muted)] leading-relaxed pt-2">Layers per level (L1 Walls, L2 Stairs…) under a RhinoDraft parent in the scripts. Units in feet.</p>
    </div>
  );
};
